import { useRef, useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { fadeInOut } from "../../atoms/Animations";
import MenuOverlay from "../../atoms/MenuOverlay";
import { SearchIcon } from "../../atoms/Icons";

export default function MenuSearch({ isVisible, setSearchOpen, translations }) {
  const searchBarRef = useRef();
  const menuOverlayRef = useRef();
  const [term, setTerm] = useState("");

  useEffect(() => {
    const htmlElement = document.documentElement;
    if (isVisible) {
      htmlElement.classList.add("search-opened");
    } else {
      htmlElement.classList.remove("search-opened");
    }

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setSearchOpen(false);
        setTerm("");
      }
    };

    const handleClickOutside = (event) => {
      if (
        menuOverlayRef.current &&
        menuOverlayRef.current.contains(event.target)
      ) {
        setSearchOpen(false);
        setTerm("");
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("click", handleClickOutside);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("click", handleClickOutside);
    };
  }, [isVisible]);

  //   Handle submit search
  const handleSubmitSearch = (term) => {
    setSearchOpen(false);
    setTimeout(() => {
      window.location.href = `/search?term=${term}`;
    }, 500);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <>
          <motion.div
            ref={searchBarRef}
            variants={fadeInOut}
            initial={"hidden"}
            animate={"visible"}
            exit="exit"
            key="menu-search"
            className="container-custom bg-gray-200 py-30 absolute w-full z-30"
          >
            <div className="relative">
              <label htmlFor="search" className="sr-only">
                Pesquisar
              </label>
              <div className="absolute left-12 top-1/2 -translate-y-1/2">
                <SearchIcon />
              </div>
              <input
                className="navbar-search w-full h-[56px] p-10 pl-44 rounded-xxxs border border-gray-500 focus-visible:outline-none bg-transparent placeholder:text-gray-700"
                type="search"
                id="search"
                name="search"
                value={term}
                placeholder={translations?.search}
                onChange={(event) => {
                  setTerm(event.target.value);
                }}
                autoComplete="off"
                onKeyDown={(e) => e.key === "Enter" && handleSubmitSearch(term)}
              />
              <button
                onClick={() => {
                  handleSubmitSearch(term);
                }}
                className="absolute right-10 top-1/2 -translate-y-1/2 btn-primary bg-gray-900 text-white border border-solid border-transparent media-hover:hover:bg-gray-800 flex items-center px-20 py-10 text-xxs rounded-xxxs font-medium duration-300"
                aria-label={translations?.search || ""}
              >
                {translations?.search}
              </button>
            </div>
          </motion.div>
          <div ref={menuOverlayRef}>
            <MenuOverlay />
          </div>
        </>
      )}
    </AnimatePresence>
  );
}
